import { Contract } from "@/types";

export const FI_SOLDERA_MEMBERSHIP_AGREEMENT_CONTRACT: Contract = {
  contract_key: "fi_soldera_membership_agreement",
  meta: {
    title:
      "signup.contract_review_component.fi.fi_soldera_membership_agreement_title",
    description:
      "signup.contract_review_component.fi.fi_soldera_membership_agreement_text",
  },
  include: true,
  can_include: true,
};

export const FI_TRANSFER_APPLICATION: Contract = {
  contract_key: "fi_transfer_application",
  meta: {
    title: "signup.contract_review_component.fi.fi_transfer_application_title",
    description:
      "signup.contract_review_component.fi.fi_transfer_application_text",
  },
  include: true,
  can_include: true,
};

export const FI_AUTHORIZATION_APPLICATION: Contract = {
  contract_key: "fi_authorization_application",
  meta: {
    title:
      "signup.contract_review_component.fi.fi_authorization_application_title",
    description:
      "signup.contract_review_component.fi.fi_authorization_application_text",
  },
  include: true,
  can_include: true,
};

export const FI_CONTRACTS_WITH_TRANSFER: Contract[] = [
  FI_TRANSFER_APPLICATION,
  FI_SOLDERA_MEMBERSHIP_AGREEMENT_CONTRACT,
];

export const FI_CONTRACTS_WITH_AUTHORIZATION: Contract[] = [
  FI_AUTHORIZATION_APPLICATION,
  FI_SOLDERA_MEMBERSHIP_AGREEMENT_CONTRACT,
];
